import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MutedSpeakerIcon } from '@streamr/tv-ui';
import styled, { keyframes } from 'styled-components';
import { StreamrAppService } from '../../services/streamrapp/StreamrAppService';
export function AudioUnmuteOverlay() {
    const blocked = StreamrAppService.getOutput().useAudioContextBlocked();
    const userMuted = StreamrAppService.getOutput().useUserMutedAudio();
    const isVideoStreaming = StreamrAppService.getOutput().useIsVideoStreaming();
    if (!blocked || userMuted || !isVideoStreaming)
        return null;
    return (_jsxs(Overlay, { onClick: () => StreamrAppService.getNotificationInterface().notifyUserGesture(), children: [_jsx(MutedSpeakerIcon, {}), _jsx("span", { children: "Click to unmute" })] }));
}
const fadeIn = keyframes `
    from { opacity: 0; transform: translateY(-0.5rem); }
    to   { opacity: 1; transform: translateY(0); }
`;
const Overlay = styled.button `
    position: absolute;
    top: 1rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
    pointer-events: auto;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 2rem;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    animation: ${fadeIn} 0.3s ease-out;
    backdrop-filter: blur(4px);
    transition: background 0.15s ease;

    &:hover {
        background: rgba(0, 0, 0, 0.85);
    }

    svg {
        width: 1.25rem;
        height: 1.25rem;
    }
`;
